var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.job.masterFlag
        ? [
            _vm.job.containerLoadType === "BCF"
              ? _c("tab-buyer-console-fcl-container", {
                  ref: "tabContainer",
                  attrs: {
                    context: _vm.context,
                    action: _vm.action,
                    "cooperate-edit": true,
                    "container-config": _vm.containerConfig
                  }
                })
              : [
                  _vm.masterCustomsDeclarationEnable
                    ? _c("tab-lcl-container-multi-so-no-mode", {
                        ref: "tabContainer",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "cooperate-edit": true,
                          "container-config": _vm.containerConfig
                        }
                      })
                    : _c("tab-lcl-container", {
                        ref: "tabContainer",
                        attrs: {
                          context: _vm.context,
                          action: _vm.action,
                          "cooperate-edit": true,
                          "container-config": _vm.containerConfig
                        }
                      })
                ]
          ]
        : _c("tab-container", {
            ref: "tabContainer",
            attrs: {
              context: _vm.context,
              action: _vm.action,
              "cooperate-edit": true,
              "slave-customs-declaration-enable":
                _vm.slaveCustomsDeclarationEnable,
              "container-config": _vm.containerConfig
            }
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }